import './style.scss';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { icons } from 'constants/icons';
import { MenuItems, MainMenuItemProps } from '../hooks';

export const HeaderMenu = (props: MenuItems) => {
  return (
    <div className="header_list">
      <div className="header_list_subMenu">
        <div className="subMenuItem" onClick={props.notice.onClick}>
          {props.notice.name}
        </div>
        {props.faq && (
          <>
            <div className="subMenuItem_item">
              <span onClick={props.faq.onClick}>{props.faq.name}</span>
              {props.faq.childItems && (
              <>
                <div className="subMenuItem_item_child">
                  {props.faq.childItems.map((childItem) => (
                    <div key={childItem.key} onClick={childItem.onClick}>
                      <span>{childItem.name}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
            </div>
          </>
        )}    
        <div className="subMenuItem" onClick={props.contact.onClick}>
          {props.contact.name}
        </div>
        <div className="header_list_subMenu_wrapper">
          <HeadersData label="口座番号" data={props.account.branch} />
          <HeadersData label="最終ログイン日" data={props.account.lastLoginDateTime} />
          <div className="logoutButton" onClick={props.logout.onClick}>
            <SvgIcon icon={icons.lock} size={IconSize.icon_xs} />
            <span>{props.logout.name}</span>
          </div>
        </div>
      </div>
      <div className="header_list_mainMenu">
        {props.items.map((item) => (
          <div className="header_list_mainMenu_item">
            <span onClick={item.onClick}>{item.name}</span>
            {item.childItems && (
              <>
                <SvgIcon icon={icons.arrow} size={IconSize.icon_s} />
                <div className="header_list_mainMenu_item_child">
                  {item.childItems.map((childItem) => (
                    <div key={childItem.key} onClick={childItem.onClick}>
                      <span>{childItem.name}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

type HeadersDataProps = {
  label: string;
  data: string;
};

const HeadersData = (props: HeadersDataProps) => {
  const { label, data } = props;
  return (
    <div className="headerData">
      <span>{label}</span>
      <span>{data}</span>
    </div>
  );
};
